import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e45af20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "message-page" }
const _hoisted_2 = { class: "total-info-container mt-5" }
const _hoisted_3 = { class: "block-one grid" }
const _hoisted_4 = { class: "scheduled-delivery-date flex flex-column lg:col-3 sm:col-12" }
const _hoisted_5 = { class: "input-component" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "配信予定日時", -1))
const _hoisted_7 = {
  key: 0,
  class: "p-error text-sm message-left"
}
const _hoisted_8 = { class: "drop-down-category flex flex-column lg:col-2 md:col-12 sm:col-12" }
const _hoisted_9 = { class: "input-component" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "ステータス", -1))
const _hoisted_11 = { class: "block-two grid mt-4" }
const _hoisted_12 = { class: "input-text-style lg:col-3 sm:col-12" }
const _hoisted_13 = { class: "input-component" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "タイトル", -1))
const _hoisted_15 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_16 = { class: "lg:col-2 sm:col-12" }
const _hoisted_17 = { class: "input-component" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "リンクURL", -1))
const _hoisted_19 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_20 = {
  key: 1,
  class: "p-error text-sm"
}
const _hoisted_21 = { class: "col-12 field grid flex-column mt-4" }
const _hoisted_22 = { class: "input-component" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "image-url",
  class: "mb-2 ml-2"
}, "画像ファイル添付", -1))
const _hoisted_24 = { class: "col-2 w-13rem upload-image" }
const _hoisted_25 = {
  key: 0,
  class: "card h-full relative border-1 surface-border"
}
const _hoisted_26 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "h-9rem w-full" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "h-auto w-full align-items-center justify-content-center" }
const _hoisted_33 = { class: "w-full h-full flex align-items-center justify-content-center" }
const _hoisted_34 = ["alt", "src"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  class: "p-error text-sm"
}
const _hoisted_37 = { class: "block-four grid mt-4" }
const _hoisted_38 = { class: "message-content flex flex-column col-12 input-component" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 required" }, "メッセージ内容", -1))
const _hoisted_40 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_41 = { class: "grid" }
const _hoisted_42 = { class: "flex mt-4 justify-content-end col-12" }

import { ApiMessageResponse } from "@/clinic/typings";
import { CategoryOptions } from "@/clinic/typings/enums/message-item";
import { ref, withDefaults, onBeforeMount, reactive } from "vue";
import { set, get } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import axios from "axios";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import InputText from "primevue/inputtext";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";

type IMessage = {
  id: number;
  status: string;
  title: string;
  send_date: string;
  targets?: Record<string, any>;
  number_of_openings: number;
  category: string;
};

type IProps = {
  channelId?: number;
  hasEdit?: boolean;
  model?: IMessage;
};

type IForm = {
  id?: number;
  selectedCategory: string;
  title: string;
  url: string;
  sendDate: Date | undefined;
  content: string;
  image?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    channelId: null,
    hasEdit: { type: Boolean, default: false },
    model: null
  },
  setup(__props: any) {

const props = __props as { channelId?: number, hasEdit: boolean, model?: IMessage };

const toast = useToast();

const validateErrors = ref(false);
const statusMessage = ref("undelivered");



const form = reactive<IForm>({
  selectedCategory: "all_user",
  title: "",
  url: "",
  sendDate: undefined,
  content: "",
  image: "",
});

const category = CategoryOptions;
const imageName = ref("ファイルを添付する");
const inputUploadImage = ref();
const isLoading = ref(false);

const showURLValidationError = ref(false);
const errorImageValidation = ref("");

const validateURL = () => {
  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  const isURLValid = urlPattern.test(get(form.url));
  set(showURLValidationError, !isURLValid && get(form.url) !== "");
};

const backToList = () => RouterUtils.goTo(RouterConstants.MESSAGE_ROUTER_NAME);

const validatePresent = value => {
  return get(validateErrors) && (value == "" || value == null);
};

const validates = () => {
  set(validateErrors, false);

  if (get(form.title) == "") {
    set(validateErrors, true);
  }
  if (get(showURLValidationError)) {
    set(validateErrors, true);
  }
  if (get(form.sendDate) == null) {
    set(validateErrors, true);
  }
  if (get(form.content) == "") {
    set(validateErrors, true);
  }

  return get(validateErrors);
};

const validateImage = () => {
  let reader = new FileReader();

  reader.readAsDataURL(get(inputUploadImage)?.files[0]);
  reader.onload = evt => {
    let img = new Image();
    img.onload = () => {
      if (get(inputUploadImage)?.files[0].size > 10000000) {
        toast.add({
          severity: "error",
          detail: "最大サイズファイル:10MB",
          life: 3000,
        });
        set(get(inputUploadImage), null);
        set(errorImageValidation, "最大サイズファイル:10MB");
        set(validateErrors, true);
      } else if (img.width >= 1024 || img.height >= 1024) {
        toast.add({
          severity: "error",
          detail: "高さ/幅 (ピクセル): 1024 未満",
          life: 3000,
        });
        set(get(inputUploadImage), null);
        set(errorImageValidation, "高さ/幅 (ピクセル): 1024 未満");
        set(validateErrors, true);
      } else {
        set(imageName, get(inputUploadImage)?.files[0]?.name);
        set(validateErrors, false);
      }
    };
    img.src = evt.target.result;
  };
};

const handleSaveButton = async ($router: any) => {
  if (validates() || get(errorImageValidation) !== "") {
    return;
  }
  var formData = new FormData();
  formData.append("title", get(form.title));
  formData.append("url", get(form.url));
  if (get(inputUploadImage)?.files[0] != undefined) {
    formData.append("image", get(inputUploadImage)?.files[0]);
  }
  formData.append("send_date", get(form.sendDate) as unknown as string);
  formData.append("content", get(form.content));
  formData.append("category", get(form.selectedCategory));

  const ApiEndpoint = ApiRouterConstants.API_SCHEDULED_MESSAGES;

  set(isLoading, true);
  if (!props.hasEdit) {
    await axios
      .post(ApiEndpoint, formData, {
        params: { channel_id: get(props.channelId) },
        headers: { Accept: "application/json" },
      })
      .then(() => {
        $router.back();
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.errors) {
          toast.add({
            severity: "error",
            detail: error.response.data.errors.join("\n"),
            life: 3000,
          });
        }
      });
  } else {
    await axios
      .patch(`${ApiEndpoint}/${form.id}`, formData, {
        params: { id: form.id, channel_id: get(props.channelId) },
        headers: { Accept: "application/json" },
      })
      .then(() => {
        $router.back();
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.errors) {
          toast.add({
            severity: "error",
            detail: error.response.data.errors.join("\n"),
            life: 3000,
          });
        }
      });
  }

  set(isLoading, false);
};

const loadModel = async () => {
  if (!props.hasEdit || !props.model?.id || props.model.id == form?.id) return;
  form.id = props.model?.id;

  const modelResult = JSON.parse(JSON.stringify(props.model));
  let {
    title,
    content,
    send_date: sendDate,
    url,
    image,
    category: selectedCategory,
    status,
  } = modelResult as ApiMessageResponse;

  set(statusMessage, status);

  sendDate = new Date(sendDate);

  const updateProps = {
    title,
    content,
    sendDate,
    url,
    image,
    selectedCategory,
  };
  Object.assign(form, updateProps);
};

onBeforeMount(() => {
  loadModel();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(Calendar), {
              class: "justify-content-end h-48 w-full",
              showIcon: "",
              modelValue: form.sendDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.sendDate) = $event)),
              showButtonBar: "",
              showTime: "",
              hourFormat: "24",
              placeholder: "配信日時"
            }, null, 8, ["modelValue"]),
            (validatePresent(form.sendDate))
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, " 必須項目です。 "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(Dropdown), {
              options: _unref(category),
              optionLabel: "name",
              optionValue: "value",
              class: "drop-down border-2 flex border-round-lg hover-border w-full h-48",
              placeholder: "ステータス",
              modelValue: form.selectedCategory,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.selectedCategory) = $event))
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_unref(InputText), {
              modelValue: form.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.title) = $event)),
              class: "input-text border-2 border-round-lg text-sm hover-border",
              placeholder: "テキスト"
            }, null, 8, ["modelValue"]),
            (validatePresent(form.title))
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, " 必須項目です。 "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_unref(InputText), {
              modelValue: form.url,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.url) = $event)),
              class: "input-text border-2 flex border-round-lg text-sm hover-border",
              placeholder: "URL",
              onInput: validateURL
            }, null, 8, ["modelValue"]),
            (validatePresent(form.url))
              ? (_openBlock(), _createElementBlock("small", _hoisted_19, " 必須項目です。 "))
              : (showURLValidationError.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_20, " 間違った形式。 "))
                : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (form.image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        role: "presentation",
                        src: form.image,
                        width: "150",
                        class: "shadow-2 mt-2 mb-2"
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("i", {
                      class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (form.image = ''))
                    })
                  ]))
                : _createCommentVNode("", true),
              (!form.image)
                ? (_openBlock(), _createBlock(_unref(FileUpload), {
                    key: 1,
                    id: "upload",
                    class: "file-upload",
                    accept: "image/png, image/jpeg",
                    ref_key: "inputUploadImage",
                    ref: inputUploadImage,
                    onChange: validateImage,
                    type: "file",
                    fileLimit: 1
                  }, {
                    header: _withCtx(({ files, chooseCallback }) => [
                      _withDirectives(_createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          class: "fake-btn h-9rem w-full flex align-items-center justify-content-center",
                          onClick: ($event: any) => (chooseCallback())
                        }, _hoisted_31, 8, _hoisted_29)
                      ], 512), [
                        [_vShow, files.length <= 0]
                      ])
                    ]),
                    content: _withCtx(({ files, removeFileCallback }) => [
                      _withDirectives(_createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: file.name + file.type + file.size,
                            class: "card h-full relative border-1 surface-border"
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("img", {
                                role: "presentation",
                                alt: file.name,
                                src: file.objectURL,
                                width: "150",
                                class: "shadow-2 mt-2 mb-2"
                              }, null, 8, _hoisted_34)
                            ]),
                            _createElementVNode("i", {
                              class: "pi pi-times-circle top-0 right-0 z-5 text-red-500 absolute",
                              onClick: 
                          () => {
                            removeFileCallback(index);
                            errorImageValidation.value = '';
                          }
                        
                            }, null, 8, _hoisted_35)
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, files?.length > 0]
                      ])
                    ]),
                    _: 1
                  }, 512))
                : _createCommentVNode("", true),
              (errorImageValidation.value != '')
                ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(errorImageValidation.value), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode(_unref(Textarea), {
            modelValue: form.content,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.content) = $event)),
            class: "text-area border-2 border-round-lg mt-2 hover-border",
            rows: "10",
            cols: "120"
          }, null, 8, ["modelValue"]),
          (validatePresent(form.content))
            ? (_openBlock(), _createElementBlock("small", _hoisted_40, " 必須項目です。 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_unref(Button), {
            label: "キャンセル",
            class: "p-button-light btn-cancel mr-3",
            onClick: backToList
          }),
          (!props.hasEdit || (props.hasEdit && __props.model?.status !== 'delivered'))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                loading: isLoading.value,
                class: "btn-save btn-primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSaveButton(_ctx.$router)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 保存する ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})